exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".xbutton {\n  width: 26px;\n  margin-top: 7px; }\n\n.xbutton:hover {\n  cursor: pointer; }\n", "", {"version":3,"sources":["/usr/src/app/src/components/Modals/UserPopup/UserPopup.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE","file":"UserPopup.scss","sourcesContent":[".xbutton {\n  width: 26px;\n  margin-top: 7px; }\n\n.xbutton:hover {\n  cursor: pointer; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./components/Modals/UserPopup/UserPopup.scss
// module id = 2086
// module chunks = 0